import { render, staticRenderFns } from "./SchemeCartoon.vue?vue&type=template&id=6f46ff6c&scoped=true"
import script from "./SchemeCartoon.vue?vue&type=script&lang=js"
export * from "./SchemeCartoon.vue?vue&type=script&lang=js"
import style0 from "./SchemeCartoon.vue?vue&type=style&index=0&id=6f46ff6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46ff6c",
  null
  
)

export default component.exports